export const errorMessage: string = 'Something went wrong!';

// promo constants
export const NEW_EVENT_PROMO_ID: string = '0';
